import React, { lazy } from 'react';
export function UpcomingEvent() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3401">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3402">
        <div className="mb-16" data-id="element-3403">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3404">
            Upcoming Event
          </h2>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3405">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/3%20bird/Feb%207%202026%205%20stand%20flyer_Page_1.jpg" alt="5-Stand Event Flyer — February 7, 2026" className="block w-full h-auto" loading="lazy" data-id="element-3406" />
          </div>
        </div>
      </div>
    </div>;
}